/** @returns {boolean} مرورگر در حالت آفلاین گزارش می‌دهد */
export function isBrowserOffline() {
  return typeof navigator !== "undefined" && navigator.onLine === false;
}

/** آیا هنگام خواندن کش، دادهٔ منقضی‌شده هم پذیرفته شود */
export function shouldAllowStaleCache() {
  return isBrowserOffline();
}
